import '@babel/polyfill'
import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import { Icon } from 'leaflet'

import store from './store'
import env from './config/env.example.js';
import {getIdentity} from './helpers/initVue.js'

delete Icon.Default.prototype._getIconUrl
//import socketio  from 'socket.io'
//import VueSocketIO from 'vue-socket.io'

import * as io from 'socket.io-client'
import VueSocketIO from 'vue-socket.io-extended'
delete Icon.Default.prototype._getIconUrl
import VueVideoPlayer from 'vue-video-player'

// require videojs style
import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'

Vue.use(VueVideoPlayer, /* {
  options: global default options,
  events: global videojs events
} */)

var {token}=getIdentity();
var SocketInstance;

if(token){
  SocketInstance = io(env.serverweb,{query: 'token='+token});
}
else{
  SocketInstance = io(env.serverweb);
}

//Vue.use(VueHead)

Vue.use(VueSocketIO,SocketInstance)

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  window.scroll(0,0)
  next()
})


/*******************************************************
 * * Configuración de los títulos de cada ruta
 *******************************************************/
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  window.scroll(0,0)
  next()
})
var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);


new Vue({
  router,
  store,
  render: h => h(App),
  sockets:{
    connect () {
        //console.log('connected to chat server')
    },
  }
}).$mount('#app')

